import React from "react";
import Toggle from "Components/toggle/Toggle";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import DropdownIndicator from "Components/customArrowSelect/CustomArrowSelect";
import Select from "Components/select/Select";
import cx from "classnames";
import Checkbox from "Components/checkbox/Checkbox";
import Repeater from "Components/repeater/Repeater";
import { isValidIPv4CIDR } from "Utils/ip";

export default class SecurityForm extends React.Component {
  state = {};

  goToNextStep = (e) => {
    e.preventDefault();
    this.props.goToStep(4);
  };

  render() {
    const {
      setFormFieldValue,
      isFormLoading,
      formData,
      formErrors,
      domain: {
        plan: { features },
      },
    } = this.props;

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("emailAccounts.add.title.step3")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              <TranslatedString>emailAccounts.add.desc.step3</TranslatedString>
            </div>
            <Button className="btnDocsFP" docsKey="emailAccount_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post">
            <div className="formsFP">
              <Toggle
                className="inputFull2"
                label={t("input.label.force_password_first_login")}
                name="force_new_password"
                checked={formData.force_new_password}
                errors={formErrors.force_new_password}
                onChange={setFormFieldValue}
              />

              {features.password_expiration && (
                <>
                  <Select
                    className={cx("inputFull2", "selectExpiration")}
                    label={t("input.label.pwd_expiration")}
                    components={{ DropdownIndicator }}
                    name="password_expiration"
                    onChange={setFormFieldValue}
                    value={parseInt(formData.password_expiration)}
                    errors={formErrors.password_expiration}
                    options={[
                      {
                        label: t("input.label.pwd_expiration.never"),
                        value: -1,
                      },
                      {
                        label: t("input.label.pwd_expiration.3"),
                        value: 3,
                      },
                      {
                        label: t("input.label.pwd_expiration.6"),
                        value: 6,
                      },
                      {
                        label: t("input.label.pwd_expiration.12"),
                        value: 12,
                      },
                    ]}
                    clearable={false}
                    inline={true}
                  />

                  <Toggle
                    className="inputFull2"
                    label={t("input.label.destroy_sessions_on_password_expiration")}
                    name="destroy_sessions_on_password_expiration"
                    checked={formData.destroy_sessions_on_password_expiration}
                    errors={formErrors.destroy_sessions_on_password_expiration}
                    onChange={setFormFieldValue}
                  />
                </>
              )}

              {features.block_old_password && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.block_old_pwd")}
                  name="block_old_password"
                  checked={formData.block_old_password}
                  errors={formErrors.block_old_password}
                  onChange={setFormFieldValue}
                />
              )}

              <Toggle
                className="inputFull2"
                label={t("input.label.disable_pwd_change")}
                name="password_change_disabled"
                checked={formData.password_change_disabled}
                errors={formErrors.password_change_disabled}
                onChange={setFormFieldValue}
              />

              {features.password_recovery_disabled && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.disable_pwd_recovery")}
                  name="password_recovery_disabled"
                  checked={formData.password_recovery_disabled}
                  errors={formErrors.password_recovery_disabled}
                  onChange={setFormFieldValue}
                />
              )}

              {this.state.resetPasswordForced && (
                <div className={cx("inputFull2")}>
                  <WarningBanner color="blue" msg={<TranslatedString>infoMsg.resetPwdForced</TranslatedString>} info />
                  <span className="internalLink" onClick={this.cancelForcePassword}>
                    {this.state.forcingResetPassword ? "Resetting" : "Reset"}
                  </span>
                </div>
              )}

              {features.force_otp && (
                <Toggle
                  className={cx("inputFull2", "inputAddMargin")}
                  label={t("input.label.force_otp")}
                  name="force_otp"
                  checked={formData.force_otp}
                  errors={formErrors.force_otp}
                  onChange={setFormFieldValue}
                />
              )}

              <Repeater
                className="inputFull2"
                labelInput={t("input.label.add.ipRestrictions")}
                label={t("listTable.header.title.ipEnabled")}
                values={formData.allow_nets}
                disabled={false /*isloggedUserInTrial*/}
                name="allow_nets"
                onChange={setFormFieldValue}
                maxValues={5}
                placeholder={t("input.placeholder.ip")}
                validateNewValue={(newVal) => {
                  if (!isValidIPv4CIDR(newVal)) {
                    alert(`${newVal} is not a valid ip address`);
                    return false;
                  }
                  return true;
                }}
              />

              {features.apply_allow_nets_webmail && (
                <Checkbox
                  className={cx("inputFull2", "inputAddMargin")}
                  label={t("input.label.ip.restrictionsToWebmail")}
                  name="apply_allow_nets_webmail"
                  onChange={setFormFieldValue}
                  checked={formData.apply_allow_nets_webmail}
                  errors={formErrors.apply_allow_nets_webmail}
                  disabled={!formData.allow_nets || formData.allow_nets.length === 0}
                />
              )}

              {features.api_enabled && (
                <Toggle
                  className="inputFull2"
                  label={t("input.label.api_enabled")}
                  name="api_enabled"
                  checked={!!formData.api_enabled}
                  errors={formErrors.api_enabled}
                  onChange={setFormFieldValue}
                />
              )}
            </div>
            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" loading={isFormLoading} onClick={this.goToNextStep}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
